/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upload_Tray_Clear_UploadInputs */



/**
* | output |
* | --- |
* | "Clear Upload" |
*
* @param {Upload_Tray_Clear_UploadInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const upload_tray_clear_upload = /** @type {((inputs?: Upload_Tray_Clear_UploadInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upload_Tray_Clear_UploadInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Upload löschen")
	return /** @type {LocalizedString} */ ("Clear Upload")
});